module.exports = __webpack_public_path__ + "img/sclogo.1571c7a0.jpg";